import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'
import dolly from '@/rahmen/utils/dolly'
import modals from '@/ddv2.library/modals'

import message from '@/ddv2.library/messages'
import tax from '@/ddv2.library/tax'
import header from '@/ddv2.library/header'
// import modals from '@/ddv2.library/modals'

import DdCustomButton from '@/components/DdCustomButton'
import DdTransparentButton from '@/components/DdTransparentButton'
import DdDateBox from '@/components/DdDateBox'
import DdCheckbox from '@/components/DdCheckbox'

const DdSubHeader = () => import('@/components/DdSubHeader')
const ThKamotsuNoTextBox = () => import('@/components/ThKamotsuNoTextBox')
const ThKoteiKamotsuNoTextBox = () => import('@/components/ThKoteiKamotsuNoTextBox')
const DdTextBox = () => import('@/components/DdTextBox')
const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdCodeTextBoxSwitching = () => import('@/components/DdCodeTextBoxSwitching')
const DdTextBoxSwitching = () => import('@/components/DdTextBoxSwitching')
const DdTimeBoxSwitching = () => import('@/components/DdTimeBoxSwitching')
const DdDropDown = () => import('@/components/DdDropDown')
const DdEditCommonBar = () => import('@/components/DdEditCommonBar')
const DdDataTable = () => import('@/components/DdDataTable')
const DdEditDialog = () => import('@/components/DdEditDialog')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdSimpleTable = () => import('@/components/DdSimpleTable')
const DdNumericBox = () => import('@/components/DdNumericBox')
const DdFooterButton = () => import('@/components/DdFooterButton')
const ThKamotsuHimodukeNippoSearchButton = () => import('@/components/ThKamotsuHimodukeNippoSearchButton')
const ThNippoNoTextBoxVKamotsu = () => import('@/components/ThNippoNoTextBoxVKamotsu')

export default {
  name: 'mockrco0020',
  mixins: [flowMixin],
  components: {
    DdCustomButton,
    DdTransparentButton,
    DdSubHeader,
    ThKamotsuNoTextBox,
    ThKoteiKamotsuNoTextBox,
    DdTextBox,
    DdDateBox,
    DdCheckbox,
    DdCodeTextBox,
    DdCodeTextBoxSwitching,
    DdTextBoxSwitching,
    DdTimeBoxSwitching,
    DdDropDown,
    DdEditCommonBar,
    DdDataTable,
    DdEditDialog,
    DdIconButtonWithTooltip,
    DdSimpleTable,
    DdNumericBox,
    DdFooterButton,
    ThKamotsuHimodukeNippoSearchButton,
    ThNippoNoTextBoxVKamotsu
  },
  data: () => ({
    invalidMessages: {},
    id: 0,
    hinmokuCount: 0,
    copyMode: 0,
    registerMode: 0,
    fechMode: 0,
    beforeHaishaKbn: '',
    step: '1',
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    rec: {
      vwJuchuKihon: {},
      mstKingaku: {},
      vwJuchuHinmokuList: [{}],
      vwUriageList: [{}]
    },
    // ----------------------------------------------------------------------------------------------------
    // バインド変数定義
    // ----------------------------------------------------------------------------------------------------
    conditionsKamotsu: {
      juchuNo: ''
    },
    conditionsNippo: {
      unkoJissekiNo: ''
    },
    /*
     * 金額項目表示用定義
     */
    recDispKingakuKomokuList: [{}],
    recDispKingakuInfo: {},
    /*
     * 商品情報編集用定義
     */
    recShohinInfo: {},
    /*
     * 売上情報編集用定義
     */
    recUriageInfo: {},
    recUriageInfoTmp: {
      sagyoMeisaiNo: '',
      uriageEigyoshoId: '',
      renrakuBiko: '',
      uriageKingaku: '',
      shiharaiUnchin: '',
      shiharaiTsukoryo: '',
      shiharaiHikazeigaku: '',
      beforeHaishaKbn: ''
    },
    // オートコンプリート定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstHinmeiHeaders: header.mstHinmeiHeaders,
    // ----------------------------------------------------------------------------------------------------
    // ダイアログ定義
    // ----------------------------------------------------------------------------------------------------
    shohinEditDialog: false,
    shohinEditIndex: -1,
    shohinMaxIndex: -1,
    uriageEditDialog: false,
    uriageEditIndex: -1,
    uriageMaxIndex: -1,
    // 表示制御
    modeKengen: 0,
    isReadonlyMode1: false,
    isReadonlyMode2: false,
    CancelButtonDisp: true,
    DeleteButtonDisp: false,
    NewButtonDisp: false,
    // CopyButtonDisp: true,
    SaveButtonDisp: true,
    hatsuchiSwitch: false,
    chakuchiSwitch: false,
    hatsuchiHmsSwitch: false,
    chakuchiHmsSwitch: false,
    hinmeiSwitch: false,
    IsOpenUriageInfo: false,
    shohinSeikyuKingakuMinyuryoku: false,
    // ----------------------------------------------------------------------------------------------------
    // データテーブル用定義
    // ----------------------------------------------------------------------------------------------------
    shohinInfoHeaders: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: 'No', value: 'juchuHinmokuNo' },
      { text: '商品種別', value: 'hinmokuSbtNm' },
      { text: '商品コード', value: 'hinmeiCd' },
      { text: '商品名', value: 'hinmeiNm' },
      { text: '数量', value: 'juchuSuryo', align: 'end' },
      { text: '単位', value: 'unitKbnNm', align: 'center' },
      { text: '玉の指定', value: 'gyoku', align: 'center' },
      { text: '操作', value: 'actions', sortable: false, width: '20px' }
    ],
    uriageInfoHeaders: [
      { text: 'ID', value: 'id', align: ' d-none' },
      { text: '売上No', value: 'sagyoMeisaiNo' },
      { text: '売上営業所', value: 'uriageEigyoshoNm' },
      { text: '日報No', value: 'unkoJissekiNo' },
      { text: '車両プレート', value: 'sharyoPlateNo' },
      { text: '乗務員', value: 'jomuinNm' },
      { text: '傭車先名', value: 'hacchusakiNm' },
      { text: '売上', value: 'uriageKingaku', align: 'end' },
      { text: '支払運賃', value: 'shiharaiUnchin', align: 'end' },
      { text: '支払通行料', value: 'shiharaiTsukoryo', align: 'end' },
      { text: '支払税抜き額', value: 'shiharaiZeinukigaku', align: 'end' },
      { text: '支払非課税額', value: 'shiharaiHikazeigaku', align: 'end' },
      { text: '操作', value: 'actions', sortable: false, width: '20px' }
    ]
  }),
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg',
      eigyoshoList: 'DDMasters/mstEigyosho',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi',
      hinmeiList: 'DDMasters/mstHinmei',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      taxList: 'DDMasters/msysTax',
      sharyoList: 'DDMasters/vwCMstSharyo',
      usersEigyosho: 'users/eigyoshoCd',
      eigyoshoLockFlg: 'users/anotherEigyoshoCtrlFlg'
    }),
    // 営業所マスタフィルター --> ここから
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    // 営業所マスタフィルター <-- ここまで
    // 荷主フィルター --> ここから
    filteredNinushiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    // 荷主フィルター <-- ここまで
    // 卸先フィルター --> ここから
    filteredOroshisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.torihikisakiBunruiKbn1 === '01'
      })
    },
    // 卸先マスタフィルター <-- ここまで
    // 発着地マスタフィルター --> ここから
    filteredHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 発着地マスタフィルター <-- ここまで
    // 品名マスタフィルター --> ここから
    filteredHinmeiList () {
      const target = filter.dateFormatter(new Date())
      return this.hinmeiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    // 品名マスタフィルター <-- ここまで
    // 単位区分フィルター
    filteredUnitKbnList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SVI001')
    },
    // 往復種別フィルター
    filteredOhfukuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'SBT006')
    },
    // 車種フィルター
    filteredSharyoShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // 品目品種フィルター
    filteredHinmokuSbtList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVIJ02')
    },
    // 商品情報テーブルフィルター --> ここから
    filteredShohinInfoRows () {
      // データがない場合の制御
      if (!this.rec.vwJuchuHinmokuList.map) { return }

      return this.rec.vwJuchuHinmokuList.map((elem) => {
        if (elem.juchuSuryo) { elem.juchuSuryo = filter.numericMinorDigitFormatter(elem.juchuSuryo, 3) }
        if (elem.juchuJuryo) { elem.juchuJuryo = filter.numericMinorDigitFormatter(elem.juchuJuryo, 3) }
        if (!elem.hinmeiCd && elem.hinmeiBiko) { elem.hinmeiNm = elem.hinmeiBiko }
        if (elem.shohinSeikyuKingaku) { elem.shohinSeikyuKingaku = filter.numericFormatter(elem.shohinSeikyuKingaku) }
        return elem
      })
    },
    // 商品情報テーブルフィルター <-- ここまで
    // 売上情報テーブルフィルター --> ここから
    filteredUriageInfoRows () {
      // データがない場合の制御
      if (!this.rec.vwUriageList.map) return
      return this.rec.vwUriageList.map((elem) => {
        if (elem.haishaKbn === '03') {
          elem.sharyoNo = elem.hacchusakiShaban
          elem.sharyoPlateNo = this.getSharyoNm(elem.hacchusakiShaban)
          elem.jininCd = elem.hacchusakiJininCd
          elem.jomuinNm = elem.hacchusakiJomuinNm
        }
        if (elem.uriageKingaku) { elem.uriageKingaku = filter.numericFormatter(elem.uriageKingaku) }
        if (elem.shiharaiUnchin) { elem.shiharaiUnchin = filter.numericFormatter(elem.shiharaiUnchin) }
        if (elem.shiharaiTsukoryo) {
          elem.shiharaiTsukoryo = filter.numericFormatter(elem.shiharaiTsukoryo)
          elem.shiharaiZeinukigaku = filter.numericFormatter(this.taxExcludedCalculation(String(elem.shiharaiTsukoryo)))
        }
        if (elem.shiharaiHikazeigaku) { elem.shiharaiHikazeigaku = filter.numericFormatter(elem.shiharaiHikazeigaku) }
        return elem
      })
    },
    // 売上情報テーブルフィルター <-- ここまで
    // 請求運賃算出
    seikyuKihonUnchinAmount () {
      // 品目レコードが存在しない場合
      if (this.rec === {}) { return 0 }
      if (this.rec.vwJuchuHinmokuList === undefined) { return 0 }
      if (this.rec.vwJuchuHinmokuList.length === 0) { return 0 }
      if (this.recShohinInfo.shohinSeikyuKingaku === null || this.recShohinInfo.shohinSeikyuKingaku === '') { return 0 }

      let amount = 0

      // 集計
      this.rec.vwJuchuHinmokuList.filter(a => {
        // 金額が数値として判定できるレコードのみ
        const target = a || {}
        return window.isFinite(this.removeComma(target.shohinSeikyuKingaku))
      }).map(k => {
        console.log('TohoKamotsu', 'parseInt', k.shohinSeikyuKingaku)
        // 金額項目を数値に変換
        return parseInt(this.removeComma(k.shohinSeikyuKingaku), 10)
      }).forEach(k => {
        amount += k
        console.log('TohoKamotsu', 'forEach', amount)
      })
      return amount
    },
    // 請求税抜き額算出
    seikyuTsukoryoZeinukiAmount () {
      if (this.isUchizeiTsukoryoInfoDisable === false) { return 0 }
      return this.taxExcludedCalculation(this.rec.vwJuchuKihon.seikyuTsukoryo)
    },
    // 請求合計金額算出
    seikyuGokeiAmount () {
      let amount = 0

      let seikyuTsukoryo = this.rec.vwJuchuKihon.seikyuTsukoryo
      if (this.isUchizeiTsukoryoInfoDisable === true) { seikyuTsukoryo = '0' }
      let seikyuKingaku1 = this.rec.vwJuchuKihon.seikyuKingaku1
      if (this.isDispUserKingaku1 === false) { seikyuKingaku1 = '0' }
      let seikyuKingaku2 = this.rec.vwJuchuKihon.seikyuKingaku2
      if (this.isDispUserKingaku2 === false) { seikyuKingaku2 = '0' }
      let seikyuKingaku3 = this.rec.vwJuchuKihon.seikyuKingaku3
      if (this.isDispUserKingaku3 === false) { seikyuKingaku3 = '0' }
      if (this.rec.vwJuchuKihon.seikyuTsukoryo === undefined || this.rec.vwJuchuKihon.seikyuTsukoryo === '') { seikyuTsukoryo = '0' }
      if (this.rec.vwJuchuKihon.seikyuKingaku1 === undefined || this.rec.vwJuchuKihon.seikyuKingaku1 === '') { seikyuKingaku1 = '0' }
      if (this.rec.vwJuchuKihon.seikyuKingaku2 === undefined || this.rec.vwJuchuKihon.seikyuKingaku2 === '') { seikyuKingaku2 = '0' }
      if (this.rec.vwJuchuKihon.seikyuKingaku3 === undefined || this.rec.vwJuchuKihon.seikyuKingaku3 === '') { seikyuKingaku3 = '0' }

      amount = this.seikyuKihonUnchinAmount + parseInt(seikyuTsukoryo, 10) + this.seikyuTsukoryoZeinukiAmount + parseInt(seikyuKingaku1, 10) + parseInt(seikyuKingaku2, 10) + parseInt(seikyuKingaku3, 10)

      return amount
    },
    // 支払運賃算出
    shiharaiKihonUnchinAmount () {
      // 支払が存在しない場合
      if (this.rec === {}) { return 0 }
      if (this.rec.vwUriageList === undefined) { return 0 }
      if (this.rec.vwUriageList.length === 0) { return 0 }
      if (this.recUriageInfo.shiharaiUnchin === null || this.recUriageInfo.shiharaiUnchin === '') { return 0 }

      let amount = 0

      // 集計
      this.rec.vwUriageList.filter(a => {
        // 金額が数値として判定できるレコードのみ
        const target = a || {}
        return window.isFinite(this.removeComma(target.shiharaiUnchin))
      }).map(k => {
        console.log('TohoKamotsu', 'parseInt', k.shiharaiUnchin)
        // 金額項目を数値に変換
        return parseInt(this.removeComma(k.shiharaiUnchin), 10)
      }).forEach(k => {
        amount += k
        console.log('TohoKamotsu', 'forEach', amount)
      })

      return amount
    },
    // 支払通行料算出
    shiharaiTsukoryoAmount () {
      // 支払が存在しない場合
      if (this.rec === {}) { return 0 }
      if (this.rec.vwUriageList === undefined) { return 0 }
      if (this.rec.vwUriageList.length === 0) { return 0 }
      if (this.recUriageInfo.shiharaiTsukoryo === null || this.recUriageInfo.shiharaiTsukoryo === '') { return 0 }

      let amount = 0

      // 集計
      this.rec.vwUriageList.filter(a => {
        // 金額が数値として判定できるレコードのみ
        const target = a || {}
        return window.isFinite(this.removeComma(target.shiharaiTsukoryo))
      }).map(k => {
        console.log('TohoKamotsu', 'parseInt', k.shiharaiTsukoryo)
        // 金額項目を数値に変換
        return parseInt(this.removeComma(k.shiharaiTsukoryo), 10)
      }).forEach(k => {
        amount += k
        console.log('TohoKamotsu', 'forEach', amount)
      })

      return amount
    },
    // 支払税抜き額算出
    shiharaiTsukoryoZeinukiAmount () {
      // 支払が存在しない場合
      if (this.rec === {}) { return 0 }
      if (this.rec.vwUriageList === undefined) { return 0 }
      if (this.shiharaiTsukoryoAmount === 0) { return 0 }

      return this.taxExcludedCalculation(String(this.shiharaiTsukoryoAmount))
    },
    // 支払非課税分算出
    shiharaiHikazeiAmount () {
      // 支払が存在しない場合
      if (this.rec === {}) { return 0 }
      if (this.rec.vwUriageList === undefined) { return 0 }
      if (this.rec.vwUriageList.length === 0) { return 0 }
      if (this.recUriageInfo.shiharaiHikazeigaku === null || this.recUriageInfo.shiharaiHikazeigaku === '') { return 0 }

      let amount = 0

      // 集計
      this.rec.vwUriageList.filter(a => {
        // 金額が数値として判定できるレコードのみ
        const target = a || {}
        return window.isFinite(this.removeComma(target.shiharaiHikazeigaku))
      }).map(k => {
        console.log('TohoKamotsu', 'parseInt', k.shiharaiHikazeigaku)
        // 金額項目を数値に変換
        return parseInt(this.removeComma(k.shiharaiHikazeigaku), 10)
      }).forEach(k => {
        amount += k
        console.log('TohoKamotsu', 'forEach', amount)
      })

      return amount
    },
    // 支払合計金額算出
    shiharaiGokeiAmount () {
      let amount = 0

      amount = this.shiharaiKihonUnchinAmount + this.shiharaiTsukoryoZeinukiAmount + this.shiharaiHikazeiAmount

      return amount
    },
    // 売上金額計算出
    uriageKingakuAmount () {
      // 支払が存在しない場合
      if (this.rec === {}) { return 0 }
      if (this.rec.vwUriageList === undefined) { return 0 }
      if (this.rec.vwUriageList.length === 0) { return 0 }
      if (this.recUriageInfo.uriageKingaku === null || this.recUriageInfo.uriageKingaku === '') { return 0 }

      let amount = 0

      // 集計
      this.rec.vwUriageList.filter(a => {
        // 金額が数値として判定できるレコードのみ
        const target = a || {}
        return window.isFinite(this.removeComma(target.uriageKingaku))
      }).map(k => {
        console.log('TohoKamotsu', 'parseInt', k.uriageKingaku)
        // 金額項目を数値に変換
        return parseInt(this.removeComma(k.uriageKingaku), 10)
      }).forEach(k => {
        amount += k
        console.log('TohoKamotsu', 'forEach', amount)
      })

      return amount
    },
    // 支払税抜き額算出
    uriageInfoShiharaiZeinukigaku () {
      if (this.rec.vwUriageList === undefined) { return 0 }
      if (this.rec.vwUriageList.length === 0) { return 0 }
      if (this.recUriageInfo.haishaKbn === null || this.recUriageInfo.shiharaiTsukoryo === '') { return 0 }
      if (this.recUriageInfo.shiharaiTsukoryo === null || this.recUriageInfo.shiharaiTsukoryo === '') { return 0 }
      return filter.numericFormatter(this.taxExcludedCalculation(this.recUriageInfo.shiharaiTsukoryo))
    },
    // 支払金額算出
    uriageInfoShiharaiGokeiAmount () {
      let amount = 0
      var shiharaiUnchin = this.recUriageInfo.shiharaiUnchin
      var shiharaiHikazeigaku = this.recUriageInfo.shiharaiHikazeigaku
      if (this.recUriageInfo.shiharaiUnchin === undefined || this.recUriageInfo.shiharaiUnchin === '' || this.recUriageInfo.shiharaiUnchin === null) { shiharaiUnchin = '0' }
      if (this.recUriageInfo.shiharaiHikazeigaku === undefined || this.recUriageInfo.shiharaiHikazeigaku === '' || this.recUriageInfo.shiharaiHikazeigaku === null) { shiharaiHikazeigaku = '0' }

      shiharaiUnchin = this.removeComma(shiharaiUnchin)
      shiharaiHikazeigaku = this.removeComma(shiharaiHikazeigaku)
      var uriageInfoShiharaiZeinukigaku = this.removeComma(this.uriageInfoShiharaiZeinukigaku)
      amount = parseInt(shiharaiUnchin, 10) + parseInt(uriageInfoShiharaiZeinukigaku, 10) + parseInt(shiharaiHikazeigaku, 10)

      return filter.numericFormatter(amount)
    },
    // 表示用編集
    dispSagyoEigyoshoCdNm () {
      if (!this.recUriageInfo.eigyoshoCd && !this.recUriageInfo.eigyoshoNm) { return null }

      return this.recUriageInfo.eigyoshoCd + ' : ' + this.recUriageInfo.eigyoshoNm
    },
    dispSharyoNoPlateNo () {
      if (!this.recUriageInfo.sharyoNo && !this.recUriageInfo.sharyoPlateNo) { return null }
      if (!this.recUriageInfo.sharyoPlateNo) { return this.recUriageInfo.sharyoNo }

      return this.recUriageInfo.sharyoNo + ' : ' + this.recUriageInfo.sharyoPlateNo
    },
    dispJomuinCdNm () {
      if (!this.recUriageInfo.jininCd && !this.recUriageInfo.jomuinNm) { return null }

      return this.recUriageInfo.jininCd + ' : ' + this.recUriageInfo.jomuinNm
    },
    dispYoshasakiCdNm () {
      if (!this.recUriageInfo.hacchusakiCd && !this.recUriageInfo.hacchusakiNm) { return null }

      return this.recUriageInfo.hacchusakiCd + ' : ' + this.recUriageInfo.hacchusakiNm
    },
    dispUserKingaku1Label () {
      if (this.recDispKingakuKomokuList.length < 1) { return '' }
      return this.recDispKingakuKomokuList[0].label
    },
    dispUserKingaku2Label () {
      if (this.recDispKingakuKomokuList.length < 2) { return '' }
      return this.recDispKingakuKomokuList[1].label
    },
    dispUserKingaku3Label () {
      if (this.recDispKingakuKomokuList.length < 3) { return '' }
      return this.recDispKingakuKomokuList[2].label
    },
    isDispUserKingaku1 () {
      return this.recDispKingakuKomokuList.length >= 1
    },
    isDispUserKingaku2 () {
      return this.recDispKingakuKomokuList.length >= 2
    },
    isDispUserKingaku3 () {
      return this.recDispKingakuKomokuList.length >= 3
    },
    isShiharaiInfoDisable () {
      var newUriageList = this.rec.vwUriageList.filter((t) => {
        return t.haishaKbn === '03' && !t.delFlg
      })
      if (newUriageList.length === 0) {
        return false
      } else {
        this.rec.vwJuchuKihon.shiharaiYoteiYmd = this.rec.vwJuchuKihon.shiharaiYoteiYmd ? this.rec.vwJuchuKihon.shiharaiYoteiYmd : this.rec.vwJuchuKihon.seikyuYoteiYmd
        return true
      }
    },
    isUchizeiTsukoryoInfoDisable () {
      return this.rec.mstKingaku.hiwayPriceShiyoFlg === true
    },
    isUriageInfoShiharaiDisable () {
      return this.recUriageInfo.haishaKbn === '03'
    },
    // ----------------------------------------------------------------------------------------------------
    // 項目制御
    // ----------------------------------------------------------------------------------------------------
    isShoukaiMode () {
      return this.modeOfEdit === 1
    },
    isCancelButtonDisplay () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1) {
        return false
      }
      return true
    },
    isDeleteButtonDisplay () {
      if (this.modeKengen === 2 && this.modeOfEdit === 2 && !this.recHaisoMeisai.seikyuZumiFlg) {
        return true
      }
      return false
    },
    isCopyButtonDisplay () {
      if (this.modeKengen !== 0 && this.modeOfEdit === 2) {
        return true
      }
      return false
    },
    isSaveButtonDisp () {
      if (this.modeKengen !== 0 && this.modeOfEdit !== 1 && !this.recHaisoMeisai.seikyuZumiFlg) {
        return true
      }
      return false
    },
    isReadOnlyBase () {
      if (this.modeKengen === 0 || this.modeOfEdit === 1 || this.recHaisoMeisai.seikyuZumiFlg || this.readOnlyMode) {
        return true
      }
      return false
    }
  },
  created () {
    this.id = this.$route.params.id
    if (this.id === '0') {
      this.id = 0
    }
  },
  mounted () {
    this.initialize()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rec: this.rec,
        hinmokuCount: this.hinmokuCount,
        hatsuchiSwitch: this.hatsuchiSwitch,
        chakuchiSwitch: this.chakuchiSwitch,
        hatsuchiHmsSwitch: this.hatsuchiHmsSwitch,
        chakuchiHmsSwitch: this.chakuchiHmsSwitch
      }
    },
    beforeRouteLeaveByMenu: function (next) {
      const option = {
        nextCallback: next
      }
      this.preventTransition(option)
    },
    fetchData: function () {
      return new Promise((resolve) => {
        this.conditionsKamotsu.juchuNo = this.rec.vwJuchuKihon.juchuNo
        console.log(this.rec.vwJuchuKihon.juchuNo)
        this.HttpClient
          .post('/api/v1/THrcod00100/KamotsuSearch', this.conditionsKamotsu)
          .then((data) => {
            if (data.payload) {
              this.hatsuchiSwitch = false
              this.chakuchiSwitch = false
              this.hatsuchiHmsSwitch = false
              this.chakuchiHmsSwitch = false
              this.fechMode = 1
              // ==================================================
              // 貨物基本情報
              // ==================================================-
              if (data.payload.vwJuchuKihon) {
                this.rec.vwJuchuKihon = data.payload.vwJuchuKihon
                if (this.rec.vwJuchuKihon.juchuYmd) {
                  this.rec.vwJuchuKihon.juchuYmd = filter.dateFormatter(this.rec.vwJuchuKihon.juchuYmd)
                } else {
                  this.rec.vwJuchuKihon.juchuYmd = filter.dateFormatter(new Date())
                }

                if (this.rec.vwJuchuKihon.hatsuchiYmd) { this.rec.vwJuchuKihon.hatsuchiYmd = filter.dateFormatter(this.rec.vwJuchuKihon.hatsuchiYmd) }

                if (this.rec.vwJuchuKihon.hatsuchiHms) { this.rec.vwJuchuKihon.hatsuchiHms = (this.rec.vwJuchuKihon.hatsuchiHms).slice(0, 5) }

                if (this.rec.vwJuchuKihon.chakuchiYmd) { this.rec.vwJuchuKihon.chakuchiYmd = filter.dateFormatter(this.rec.vwJuchuKihon.chakuchiYmd) }

                if (this.rec.vwJuchuKihon.chakuchiHms) { this.rec.vwJuchuKihon.chakuchiHms = (this.rec.vwJuchuKihon.chakuchiHms).slice(0, 5) }

                if (this.rec.vwJuchuKihon.seikyuYoteiYmd) { this.rec.vwJuchuKihon.seikyuYoteiYmd = filter.dateFormatter(this.rec.vwJuchuKihon.seikyuYoteiYmd) }

                if (this.rec.vwJuchuKihon.shiharaiYoteiYmd) { this.rec.vwJuchuKihon.shiharaiYoteiYmd = filter.dateFormatter(this.rec.vwJuchuKihon.shiharaiYoteiYmd) }

                if (this.rec.vwJuchuKihon.hinmokuCount) { this.hinmokuCount = this.rec.vwJuchuKihon.hinmokuCount }

                if (!this.rec.vwJuchuKihon.hatsuchiId && this.rec.vwJuchuKihon.hatsuchiBiko) { this.hatsuchiSwitch = true }

                if (!this.rec.vwJuchuKihon.hatsuchiHms && this.rec.vwJuchuKihon.hatsuchiHmsBiko) { this.hatsuchiHmsSwitch = true }

                if (!this.rec.vwJuchuKihon.chakuchiId && this.rec.vwJuchuKihon.chakuchiBiko) { this.chakuchiSwitch = true }

                if (!this.rec.vwJuchuKihon.chakuchiHms && this.rec.vwJuchuKihon.chakuchiHmsBiko) { this.chakuchiHmsSwitch = true }
              }
              // ==================================================
              // 金額マスタ情報
              // ==================================================-
              if (data.payload.mstKingaku) {
                this.rec.mstKingaku = data.payload.mstKingaku
              }
              // ==================================================
              // 商品情報
              // ==================================================-
              if (data.payload.vwJuchuHinmokuList) {
                this.rec.vwJuchuHinmokuList = data.payload.vwJuchuHinmokuList
              }
              // ==================================================
              // 売上情報
              // ==================================================-
              if (data.payload.vwUriageList) {
                this.rec.vwUriageList = data.payload.vwUriageList
              }
              // 複写ボタン押下時
              if (this.copyMode === 1) {
                this.rec.vwJuchuKihon.id = 0
                this.rec.vwJuchuKihon.juchuNo = null
                this.rec.vwUriageList = []
                this.DeleteButtonDisp = false
                this.NewButtonDisp = true
                // this.CopyButtonDisp = true
                this.isReadonlyMode1 = false
                this.isReadonlyMode2 = false
                this.$refs.juchuNo.innerValue = null
              // 通常時
              } else if (this.copyMode === 0) {
                if (this.rec.vwJuchuKihon.id === 0) {
                  // 新規モード
                  this.modeOfEdit = 0
                } else if (this.rec.vwJuchuKihon.seikyuZumiFlg === false) {
                  // 更新1：更新モードかつ請求済みフラグ==false
                  this.modeOfEdit = 1
                } else {
                  // 更新2：更新モードかつ請求済みフラグ==true
                  this.modeOfEdit = 2
                }

                if (this.modeOfEdit !== 0) {
                  this.isReadonlyMode1 = true
                } else {
                  this.isReadonlyMode1 = false
                }
                if (this.modeOfEdit === 2) {
                  this.isReadonlyMode2 = true
                } else {
                  this.isReadonlyMode2 = false
                }
                if (this.modeKengen === 2 && this.modeOfEdit === 1) {
                  this.DeleteButtonDisp = true
                } else {
                  this.DeleteButtonDisp = false
                }

                /* if (this.modeOfEdit === 0) {
                  this.CopyButtonDisp = true
                } else {
                  this.CopyButtonDisp = false
                } */

                if (this.modeOfEdit !== 0) {
                  this.NewButtonDisp = true
                } else {
                  this.NewButtonDisp = false
                }
              }
              if (this.registerMode !== 1) {
                this.clearSummaryMessage()
              }
              this.copyMode = 0
              this.registerMode = 0
              this.clearInvalidMessage(this.$refs)
              this.cloneData = dolly.clone(this.getCloneTargetMethod())
              console.log(this.cloneData, 'teketo')
            } else {
              this.$refs.juchuNo[this.Ctrls.SET_INVALID_METHOD](message.get('COMI0101'))
            }
            resolve()
          })
      })
    },
    initialize () {
      console.log('initialize')
      const self = this
      const option = {
        loadMasters: ['msteigyosho', 'msttorihikisaki', 'msthacchakuchi', 'msthinmei', 'mstshubetsu', 'msyskubun', 'vwcmstsharyo', 'msystax'],
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: function (c) {
          return new Promise((resolve) => {
            console.log('savedInputRestorePromise')
            // ユーザ保存項目の復元
            self.rec.vwJuchuKihon.ohfukuSbt = c.ohfukuSbt
            self.rec.vwJuchuKihon.seikyuShashuSbt = c.seikyuShashuSbt
            resolve()
          })
        },
        existsIdMethod: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          return new Promise((resolve) => {
            console.log('★★★settingButtonStatePromise★★★', kengen.kengenKbn)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            if (self.modeKengen === 0) {
              self.SaveButtonDisp = false
            }

            self.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })
            resolve()
          })
        }
      }
      console.info('call initializeForRegister', this.initializeForRegister, option)
      this.initializeForRegister(option)
    },
    // ----------------------------------------------------------------------------------------------------
    // 貨物No反映ボタン押下
    // ----------------------------------------------------------------------------------------------------
    // ポップアップから選択時
    kamotsuNoDialogSync: function (p) {
      console.log(' **** XXXXX **** kamotsuNoDialogSync', p)
      this.rec.vwJuchuKihon.juchuNo = p
      this.kamotsuNoSync()
    },
    // 反映ボタン押下時
    kamotsuNoSync: function (p) {
      console.log(' **** XXXXX **** kamotsuNoSync', p)
      this.fetchData()
    },
    // ----------------------------------------------------------------------------------------------------
    // 固定貨物No反映ボタン押下
    // ----------------------------------------------------------------------------------------------------
    // ポップアップから選択時
    koteiKamostuNoDialogSync: function (p) {
      console.log(' **** XXXXX **** koteiKamostuNoDialogSync', p)
      this.rec.vwJuchuKihon.koteiKamotsuNo = p
      this.getKoteiKamotsuInfo()
    },
    // 反映ボタン押下時
    koteiKamostuNoSync: function (p) {
      console.log(' **** XXXXX **** koteiKamostuNoSync', p)
      this.rec.vwJuchuKihon.koteiKamotsuNo = this.rec.vwJuchuKihon.teikeiKihonNo
      this.getKoteiKamotsuInfo()
    },
    getKoteiKamotsuInfo: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/Thrcod00100/KoteiKamotsuInfoFind?koteiKamotsuNo=${this.rec.vwJuchuKihon.koteiKamotsuNo}`)
          .then((data) => {
            if (data.payload) {
              this.hatsuchiSwitch = false
              this.chakuchiSwitch = false
              this.hatsuchiHmsSwitch = false
              this.chakuchiHmsSwitch = false
              // ==================================================
              // 貨物基本情報
              // ==================================================-
              if (data.payload.vwJuchuKihon) {
                this.rec.vwJuchuKihon = data.payload.vwJuchuKihon

                this.rec.vwJuchuKihon.juchuYmd = filter.dateFormatter(new Date())

                if (this.rec.vwJuchuKihon.hatsuchiHms) { this.rec.vwJuchuKihon.hatsuchiHms = (this.rec.vwJuchuKihon.hatsuchiHms).slice(0, 5) }

                if (this.rec.vwJuchuKihon.chakuchiHms) { this.rec.vwJuchuKihon.chakuchiHms = (this.rec.vwJuchuKihon.chakuchiHms).slice(0, 5) }

                if (this.rec.vwJuchuKihon.hinmokuCount) { this.hinmokuCount = this.rec.vwJuchuKihon.hinmokuCount }

                if (!this.rec.vwJuchuKihon.hatsuchiId && this.rec.vwJuchuKihon.hatsuchiBiko) { this.hatsuchiSwitch = true }

                if (!this.rec.vwJuchuKihon.hatsuchiHms && this.rec.vwJuchuKihon.hatsuchiHmsBiko) { this.hatsuchiHmsSwitch = true }

                if (!this.rec.vwJuchuKihon.chakuchiId && this.rec.vwJuchuKihon.chakuchiBiko) { this.chakuchiSwitch = true }

                if (!this.rec.vwJuchuKihon.chakuchiHms && this.rec.vwJuchuKihon.chakuchiHmsBiko) { this.chakuchiHmsSwitch = true }
              }
              // ==================================================
              // 金額マスタ情報
              // ==================================================-
              if (data.payload.mstKingaku) {
                this.rec.mstKingaku = data.payload.mstKingaku
              }
              // ==================================================
              // 商品情報
              // ==================================================-
              if (data.payload.vwJuchuHinmokuList) {
                this.rec.vwJuchuHinmokuList = data.payload.vwJuchuHinmokuList
              }
              this.NewButtonDisp = true
              this.clearInvalidMessage(this.$refs)
              this.clearSummaryMessage()
              this.cloneData = dolly.clone(this.getCloneTargetMethod())
            } else {
              this.$refs.teikeiKihonNo[this.Ctrls.SET_INVALID_METHOD](message.get('COMI0101'))
            }
            resolve()
          })
      })
    },
    // ----------------------------------------------------------------------------------------------------
    // 金額項目設定情報取得
    // ----------------------------------------------------------------------------------------------------
    // 荷主IDが入力されたら、金額項目設定情報を取得メソッドを呼ぶ
    changeNinushi: function () {
      if (!this.rec.vwJuchuKihon.ninushiId) {
        this.recDispKingakuKomokuList = []
        this.recDispKingakuInfo = {}
        return
      }
      console.log('changeNinushiId')
      this.getKingakuKomoku(this.rec.vwJuchuKihon.ninushiId)
    },
    getKingakuKomoku: function () {
      return new Promise((resolve) => {
        this.HttpClient
          .get(`/api/v1/Thrcod00100/KingakuInfoFind?id=${this.rec.vwJuchuKihon.ninushiId}`)
          .then((data) => {
            this.rec.mstKingaku = data.payload
            console.log('getKingakuKomoku', this.rec.mstKingaku)
            this.kingakuSetting()
          })
        resolve()
      })
    },
    kingakuSetting: function () {
      this.recDispKingakuKomokuList = []
      if (this.rec.mstKingaku === null) { return }
      // 通行料課税・内税どちらか一方のみ設定されていない場合、エラー
      if (this.rec.mstKingaku.hiwayPriceShiyoFlg === true && this.rec.mstKingaku.userKingakuKazei10ShiyoFlg === true) { return this.setInvalidSummaryMessage('COME0023') }
      if (this.rec.mstKingaku.hiwayPriceShiyoFlg === false && this.rec.mstKingaku.userKingakuKazei10ShiyoFlg === false) { return this.setInvalidSummaryMessage('COME0023') }

      if (this.rec.mstKingaku.userKingakuKazei1ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuKazei1Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      if (this.rec.mstKingaku.userKingakuKazei2ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuKazei2Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      if (this.rec.mstKingaku.userKingakuKazei3ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuKazei3Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      if (this.rec.mstKingaku.userKingakuHikazei1ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuHikazei1Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      if (this.rec.mstKingaku.userKingakuHikazei2ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuHikazei2Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      if (this.rec.mstKingaku.userKingakuHikazei3ShiyoFlg === true) {
        this.recDispKingakuInfo = {}
        this.recDispKingakuInfo.label = this.rec.mstKingaku.userKingakuHikazei3Title

        if (this.recDispKingakuKomokuList.length > 0) {
          this.recDispKingakuKomokuList.push(this.recDispKingakuInfo)
        } else {
          this.recDispKingakuKomokuList = [this.recDispKingakuInfo]
        }
      }
      // ユーザ選択金額項目が4項目以上設定されていた場合、エラー
      if (this.recDispKingakuKomokuList.length > 3) {
        this.recDispKingakuKomokuList = []
        this.recDispKingakuInfo = {}
        return this.setInvalidSummaryMessage('COME0024')
      }
      // 請求・支払予定年月日初期値取得
      if (this.fechMode === 0) {
        if (this.rec.mstKingaku.keijobiKbn === '1' && this.rec.vwJuchuKihon.hatsuchiYmd !== null && this.rec.vwJuchuKihon.hatsuchiYmd !== '' && this.rec.vwJuchuKihon.hatsuchiYmd !== undefined) {
          this.rec.vwJuchuKihon.seikyuYoteiYmd = this.rec.vwJuchuKihon.hatsuchiYmd
          this.rec.vwJuchuKihon.shiharaiYoteiYmd = this.rec.vwJuchuKihon.hatsuchiYmd
        } else if (this.rec.mstKingaku.keijobiKbn === '2' && this.rec.vwJuchuKihon.chakuchiYmd !== null && this.rec.vwJuchuKihon.chakuchiYmd !== '' && this.rec.vwJuchuKihon.chakuchiYmd !== undefined) {
          this.rec.vwJuchuKihon.seikyuYoteiYmd = this.rec.vwJuchuKihon.chakuchiYmd
          this.rec.vwJuchuKihon.shiharaiYoteiYmd = this.rec.vwJuchuKihon.chakuchiYmd
        } else {
          this.rec.vwJuchuKihon.seikyuYoteiYmd = this.rec.vwJuchuKihon.juchuYmd
          this.rec.vwJuchuKihon.shiharaiYoteiYmd = this.rec.vwJuchuKihon.juchuYmd
        }
      } else {
        this.fechMode = 0
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 積日付・卸日付初期値取得
    // ----------------------------------------------------------------------------------------------------
    inputJuchuYmd: function () {
      if (this.rec.vwJuchuKihon.juchuYmd !== undefined && this.rec.vwJuchuKihon.juchuYmd !== '' && this.rec.vwJuchuKihon.juchuYmd !== null) {
        this.$refs.hatsuchiYmd.onCalendarInput(this.rec.vwJuchuKihon.juchuYmd)
        this.$refs.chakuchiYmd.onCalendarInput(this.rec.vwJuchuKihon.juchuYmd)
        this.$refs.seikyuYoteiYmd.onCalendarInput(this.rec.vwJuchuKihon.juchuYmd)
        this.$refs.shiharaiYoteiYmd.onCalendarInput(this.rec.vwJuchuKihon.juchuYmd)
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 請求・支払予定年月日初期値取得
    // ----------------------------------------------------------------------------------------------------
    inputYmd: function () {
      if (this.rec.mstKingaku.keijobiKbn !== undefined) {
        if (this.rec.mstKingaku.keijobiKbn === '1' && this.rec.vwJuchuKihon.hatsuchiYmd !== null && this.rec.vwJuchuKihon.hatsuchiYmd !== '' && this.rec.vwJuchuKihon.hatsuchiYmd !== undefined) {
          this.rec.vwJuchuKihon.seikyuYoteiYmd = this.rec.vwJuchuKihon.hatsuchiYmd
          this.rec.vwJuchuKihon.shiharaiYoteiYmd = this.rec.vwJuchuKihon.hatsuchiYmd
        } else if (this.rec.mstKingaku.keijobiKbn === '2' && this.rec.vwJuchuKihon.chakuchiYmd !== null && this.rec.vwJuchuKihon.chakuchiYmd !== '' && this.rec.vwJuchuKihon.chakuchiYmd !== undefined) {
          this.rec.vwJuchuKihon.seikyuYoteiYmd = this.rec.vwJuchuKihon.chakuchiYmd
          this.rec.vwJuchuKihon.shiharaiYoteiYmd = this.rec.vwJuchuKihon.chakuchiYmd
        } else {
          this.rec.vwJuchuKihon.seikyuYoteiYmd = this.rec.vwJuchuKihon.juchuYmd
          this.rec.vwJuchuKihon.shiharaiYoteiYmd = this.rec.vwJuchuKihon.juchuYmd
        }
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 支払予定年月日初期値取得(請求予定日入力時)
    // ----------------------------------------------------------------------------------------------------
    inputSeikyuYoteiYmd: function () {
      if (this.rec.vwJuchuKihon.seikyuYoteiYmd !== undefined && this.rec.vwJuchuKihon.seikyuYoteiYmd !== '' && this.rec.vwJuchuKihon.seikyuYoteiYmd !== null) {
        this.$refs.shiharaiYoteiYmd.onCalendarInput(this.rec.vwJuchuKihon.seikyuYoteiYmd)
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 商品情報編集
    // ----------------------------------------------------------------------------------------------------
    onShohinEditNewButtonClick: function (item) {
      if (this.isReadonlyMode2 === true) { return }
      this.shohinEditIndex = -1
      this.recShohinInfo = {}
      this.$set(this.recShohinInfo, 'shohinSeikyuKingaku', '')
      this.recShohinInfo.id = -1
      this.recShohinInfo.hinmokuSbt = null
      this.recShohinInfo.unitKbn = null
      this.shohinSeikyuKingakuMinyuryoku = true
      this.hinmeiSwitch = false
      // this.shohinEditDialog = true
      this.$modal.show('shohin-edit-dialog')
    },
    onShohinEditOpenButtonClick: function (item) {
      this.shohinEditIndex = this.rec.vwJuchuHinmokuList.indexOf(item)
      this.recShohinInfo = Object.assign({}, item)
      if (!this.recShohinInfo.mstHinmeiId && this.recShohinInfo.hinmeiBiko) { this.hinmeiSwitch = true }
      this.shohinSeikyuKingakuMinyuryoku = false
      // this.shohinEditDialog = true
      this.$modal.show('shohin-edit-dialog')
    },
    onShohinEditMoveUpButtonClick: function (item) {
      const index = this.rec.vwJuchuHinmokuList.indexOf(item)
      if (index === 0 || index === -1) { return }
      this.rec.vwJuchuHinmokuList.splice(
        index - 1,
        2,
        this.rec.vwJuchuHinmokuList[index],
        this.rec.vwJuchuHinmokuList[index - 1])
      const tempJuchuHinmokuNo = this.rec.vwJuchuHinmokuList[index - 1].juchuHinmokuNo
      this.rec.vwJuchuHinmokuList[index - 1].juchuHinmokuNo = this.rec.vwJuchuHinmokuList[index].juchuHinmokuNo
      this.rec.vwJuchuHinmokuList[index].juchuHinmokuNo = tempJuchuHinmokuNo
    },
    onShohinEditMoveDownButtonClick: function (item) {
      const index = this.rec.vwJuchuHinmokuList.indexOf(item)
      if (index === this.rec.vwJuchuHinmokuList.length - 1 || index === -1) { return }
      this.rec.vwJuchuHinmokuList.splice(
        index,
        2,
        this.rec.vwJuchuHinmokuList[index + 1],
        this.rec.vwJuchuHinmokuList[index])
      const tempJuchuHinmokuNo = this.rec.vwJuchuHinmokuList[index].juchuHinmokuNo
      this.rec.vwJuchuHinmokuList[index].juchuHinmokuNo = this.rec.vwJuchuHinmokuList[index + 1].juchuHinmokuNo
      this.rec.vwJuchuHinmokuList[index + 1].juchuHinmokuNo = tempJuchuHinmokuNo
    },
    onShohinEditDeleteButtonClick: function (item) {
      if (this.isReadonlyMode2 === true) { return }
      const index = this.rec.vwJuchuHinmokuList.indexOf(item)
      this.recShohinInfo = Object.assign({}, item)
      this.recShohinInfo.editFlg = true
      this.recShohinInfo.delFlg = !this.recShohinInfo.delFlg
      this.recShohinInfo.shohinSeikyuKingaku = '0'
      Object.assign(this.rec.vwJuchuHinmokuList[index], this.recShohinInfo)
    },
    onShohinEditCloseButtonClick: function () {
      this.hinmeiSwitch = false
      // this.shohinEditDialog = false
      this.$modal.hide('shohin-edit-dialog')
      this.$nextTick(() => {
        this.recShohinInfo = Object.assign({}, null)
        this.recShohinInfo.mstHinmeiId = null
        this.shohinEditIndex = -1
        this.shohinSeikyuKingakuMinyuryoku = true
      })
    },
    onShohinEditSaveButtonClick: function () {
      // 商品種別
      this.recShohinInfo.hinmokuSbtNm = this.getShubetsuNm('GVIJ02', this.recShohinInfo.hinmokuSbt)
      // 単位
      this.recShohinInfo.unitKbnNm = this.getShubetsuNm('SVI001', this.recShohinInfo.unitKbn)
      // 品名名称
      this.recShohinInfo.hinmeiCd = this.getHinmeiCd(this.recShohinInfo.mstHinmeiId)
      this.recShohinInfo.hinmeiNm = this.getHinmeiNm(this.recShohinInfo.mstHinmeiId)
      // 数値項目が入力されていないとき、0を代入
      if (!this.recShohinInfo.juchuSuryo) { this.recShohinInfo.juchuSuryo = '0' }
      if (!this.recShohinInfo.juchuJuryo) { this.recShohinInfo.juchuJuryo = '0' }
      if (!this.recShohinInfo.tanka) { this.recShohinInfo.tanka = '0' }
      if (!this.recShohinInfo.shohinSeikyuKingaku) { this.recShohinInfo.shohinSeikyuKingaku = '0' }

      if (this.shohinEditIndex > -1) {
        this.recShohinInfo.editFlg = true
        Object.assign(this.rec.vwJuchuHinmokuList[this.shohinEditIndex], this.recShohinInfo)
        this.onShohinEditCloseButtonClick()
      } else {
        this.recShohinInfo.id = -1
        this.recShohinInfo.editFlg = true
        this.recShohinInfo.delFlg = false
        // 受注明細品目番号 ※FechDataでこの受注明細に紐づく品目データのMAX値を取得しといて、そこに+1する。this.rec.vwJuchuHinmokuList.HinmokuCount
        this.hinmokuCount++
        this.recShohinInfo.juchuHinmokuNo = this.hinmokuCount

        if (this.rec.vwJuchuHinmokuList.length > 0) {
          this.rec.vwJuchuHinmokuList.push(this.recShohinInfo)
        } else {
          this.rec.vwJuchuHinmokuList = [this.recShohinInfo]
        }
      }
      this.recShohinInfo = {}
      this.recShohinInfo.id = -1
      this.recShohinInfo.hinmokuSbt = null
      this.recShohinInfo.unitKbn = null
      this.recShohinInfo.mstHinmeiId = null
      this.$refs.mstHinmeiId.innerValue = null
      this.$set(this.recShohinInfo, 'shohinSeikyuKingaku', '')
      this.hinmeiSwitch = false
    },
    onSaveShohinInfo: function (row, target, input) {
      if (input === undefined) { return false }
      const inputPrice = this.removeComma(input)
      if (!window.isFinite(inputPrice)) { return }
      row[target] = filter.numericFormatter(inputPrice)
      this.rec.vwJuchuHinmokuList.splice()
    },
    onReturnButtonClick: function (e) {
      console.log('onReturnButtonClick', e)
      const self = this
      const opt = {
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        }
      }

      this.transitionBack(opt)
    },
    // ----------------------------------------------------------------------------------------------------
    // 数量*単価で商品情報請求金額の初期値を設定 ※商品情報請求金額未入力時
    // ----------------------------------------------------------------------------------------------------
    calcShohinSeikyuKingaku: function () {
      if (this.shohinSeikyuKingakuMinyuryoku) {
        if (this.recShohinInfo.juchuSuryo && this.recShohinInfo.tanka) {
          var calcSeikyuUnchin = this.recShohinInfo.juchuSuryo * this.recShohinInfo.tanka
          calcSeikyuUnchin = calcSeikyuUnchin === 0 ? 0 : Math.round(calcSeikyuUnchin)
          this.$set(this.recShohinInfo, 'shohinSeikyuKingaku', calcSeikyuUnchin)
        }
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 商品情報請求金額を変更時の自動計算挙動制御
    // ----------------------------------------------------------------------------------------------------
    inputShohinSeikyuKingaku: function () {
      if (this.recShohinInfo.shohinSeikyuKingaku === null || this.recShohinInfo.shohinSeikyuKingaku === '') {
        this.shohinSeikyuKingakuMinyuryoku = true
      } else {
        this.shohinSeikyuKingakuMinyuryoku = false
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 貨物紐付け可能日報検索
    // ----------------------------------------------------------------------------------------------------
    kamotsuHimodukeNippoSearchSync: function (p) {
      console.log(' **** XXXXX **** kamotsuHimodukeNippoSearchSync', p)
      if (this.isReadonlyMode2 === true) { return }
      for (let i = 0; i < p.length; i++) {
        const res = this.rec.vwUriageList.find((v) => v.unkoJissekiNo === p[i].unkoJissekiNo)
        if (res) { continue }
        this.recUriageInfo.editFlg = true
        this.recUriageInfo.delFlg = false
        this.recUriageInfo.id = -1
        this.recUriageInfo.uriageEigyoshoId = this.getEigyoshoId(this.usersEigyosho)
        this.recUriageInfo.eigyoshoCd = p[i].eigyoshoCd
        this.recUriageInfo.eigyoshoNm = p[i].eigyoshoNm
        this.recUriageInfo.unkoJissekiNo = p[i].unkoJissekiNo
        this.recUriageInfo.sharyoNo = p[i].sharyoNo
        this.recUriageInfo.sharyoPlateNo = p[i].sharyoPlateNo
        this.recUriageInfo.jininCd = p[i].jininCd
        this.recUriageInfo.jomuinNm = p[i].jomuinNm
        this.recUriageInfo.hacchusakiCd = p[i].hacchusakiCd
        this.recUriageInfo.hacchusakiNm = p[i].hacchusakiNm
        this.recUriageInfo.uriageKingaku = String(p[i].uriageKingaku)
        this.recUriageInfo.shiharaiUnchin = String(p[i].shiharaiUnchin)
        this.recUriageInfo.shiharaiTsukoryo = String(p[i].shiharaiTsukoryo)
        this.recUriageInfo.shiharaiHikazeigaku = String(p[i].shiharaiHikazeigaku)
        this.recUriageInfo.renrakuBiko = p[i].renrakuBiko
        this.recUriageInfo.haishaKbn = p[i].haishaKbn

        if (this.rec.vwUriageList.length > 0) {
          this.rec.vwUriageList.push(this.recUriageInfo)
        } else {
          this.rec.vwUriageList = [this.recUriageInfo]
        }
        this.recUriageInfo = {}
        this.recUriageInfo.unkoJissekiNo = null
      }
    },
    // ----------------------------------------------------------------------------------------------------
    // 売上情報編集
    // ----------------------------------------------------------------------------------------------------
    onUriageEditNewButtonClick: function (item) {
      console.log('onUriageEditNewButtonClick')
      if (this.isReadonlyMode2 === true) { return }
      this.uriageEditIndex = -1
      this.recUriageInfo = {}
      this.recUriageInfo.id = -1
      this.recUriageInfo.uriageEigyoshoId = this.getEigyoshoId(this.usersEigyosho)
      this.beforeHaishaKbn = null
      this.$set(this.recUriageInfo, 'uriageKingaku', '')
      this.$set(this.recUriageInfo, 'shiharaiUnchin', '')
      this.$set(this.recUriageInfo, 'shiharaiTsukoryo', '')
      this.$set(this.recUriageInfo, 'shiharaiHikazeigaku', '')
      // this.uriageEditDialog = true
      this.$modal.show('uriage-edit-dialog')
      this.IsOpenUriageInfo = true
    },
    onUriageEditOpenButtonClick: function (item) {
      this.uriageEditIndex = this.rec.vwUriageList.indexOf(item)
      this.recUriageInfo = Object.assign({}, item)
      this.beforeHaishaKbn = this.recUriageInfo.haishaKbn
      // this.uriageEditDialog = true
      this.$modal.show('uriage-edit-dialog')
      this.IsOpenUriageInfo = true
    },
    onUriageEditDeleteButtonClick: function (item) {
      if (this.isReadonlyMode2 === true) { return }
      const index = this.rec.vwUriageList.indexOf(item)
      this.recUriageInfo = Object.assign({}, item)
      this.recUriageInfo.editFlg = true
      this.recUriageInfo.delFlg = !this.recUriageInfo.delFlg
      this.recUriageInfo.uriageKingaku = '0'
      this.recUriageInfo.shiharaiUnchin = '0'
      this.recUriageInfo.shiharaiTsukoryo = '0'
      this.recUriageInfo.shiharaiHikazeigaku = '0'
      this.recUriageInfo.shiharaiZeinukigaku = '0'

      Object.assign(this.rec.vwUriageList[index], this.recUriageInfo)
      this.rec.vwUriageList.splice()
    },
    onUriageEditCloseButtonClick: function () {
      // this.uriageEditDialog = false
      this.$modal.hide('uriage-edit-dialog')
      this.IsOpenUriageInfo = false
      this.recUriageInfoTmp = {}
      this.$refs.uriageEigyoshoId.invalidMessage = undefined
      this.$refs.unkoJissekiNo.invalidMessage = undefined
      this.$nextTick(() => {
        this.recUriageInfo = Object.assign({}, null)
        this.recUriageInfo.sagyoMeisaiNo = null
        this.recUriageInfo.uriageEigyoshoId = null
        this.recUriageInfo.unkoJissekiNo = null
        this.beforeHaishaKbn = null
        this.uriageEditIndex = -1
      })
    },
    onUriageEditSaveButtonClick: function () {
      if (this.recUriageInfo.uriageEigyoshoId === null || this.recUriageInfo.uriageEigyoshoId === '' || this.recUriageInfo.uriageEigyoshoId === undefined) {
        this.$refs.uriageEigyoshoId[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0001'))
        return
      }
      if (this.recUriageInfo.unkoJissekiNo !== null && this.recUriageInfo.unkoJissekiNo !== '' && this.recUriageInfo.unkoJissekiNo !== undefined) {
        const res = this.rec.vwUriageList.find((v) => v.unkoJissekiNo === this.recUriageInfo.unkoJissekiNo)
        const index = this.rec.vwUriageList.indexOf(res)
        if (res && this.uriageEditIndex !== index) {
          this.$refs.unkoJissekiNo[this.Ctrls.SET_INVALID_METHOD](message.get('RCOE0003'))
          return
        }
      }
      if (this.beforeHaishaKbn !== null && this.recUriageInfo.haishaKbn !== this.beforeHaishaKbn && this.recUriageInfo.sagyoMeisaiNo) {
        if (this.recUriageInfo.unkoJissekiNo !== null && this.recUriageInfo.unkoJissekiNo !== '' && this.recUriageInfo.unkoJissekiNo !== undefined) {
          this.$refs.unkoJissekiNo[this.Ctrls.SET_INVALID_METHOD](message.get('RCOE0002'))
        } else {
          this.$refs.unkoJissekiNo[this.Ctrls.SET_INVALID_METHOD](message.get('RCOE0005'))
        }
        return
      }
      if (this.uriageEditIndex > -1) {
        this.recUriageInfo.editFlg = true
        this.recUriageInfo.uriageEigyoshoNm = this.getEigyoshoNm(this.recUriageInfo.uriageEigyoshoId)
        Object.assign(this.rec.vwUriageList[this.uriageEditIndex], this.recUriageInfo)
        this.onUriageEditCloseButtonClick()
      } else {
        this.recUriageInfo.id = -1
        this.recUriageInfo.editFlg = true
        this.recUriageInfo.delFlg = false
        this.recUriageInfo.uriageEigyoshoNm = this.getEigyoshoNm(this.recUriageInfo.uriageEigyoshoId)
        // 数値項目が入力されていないとき、0を代入
        if (!this.recUriageInfo.uriageKingaku) { this.recUriageInfo.uriageKingaku = '0' }
        if (!this.recUriageInfo.shiharaiUnchin) { this.recUriageInfo.shiharaiUnchin = '0' }
        if (!this.recUriageInfo.shiharaiTsukoryo) { this.recUriageInfo.shiharaiTsukoryo = '0' }
        if (!this.recUriageInfo.shiharaiHikazeigaku) { this.recUriageInfo.shiharaiHikazeigaku = '0' }

        if (this.rec.vwUriageList.length > 0) {
          this.rec.vwUriageList.push(this.recUriageInfo)
        } else {
          this.rec.vwUriageList = [this.recUriageInfo]
        }
      }
      this.recUriageInfo = {}
      this.recUriageInfo.id = -1
      this.recUriageInfo.uriageEigyoshoId = this.getEigyoshoId(this.usersEigyosho)
      this.recUriageInfo.unkoJissekiNo = null
      this.$refs.uriageEigyoshoId.innerValue = this.getEigyoshoId(this.usersEigyosho)
      this.$refs.unkoJissekiNo.innerValue = null
      this.$set(this.recUriageInfo, 'uriageKingaku', '')
      this.$set(this.recUriageInfo, 'shiharaiUnchin', '')
      this.$set(this.recUriageInfo, 'shiharaiTsukoryo', '')
      this.$set(this.recUriageInfo, 'shiharaiHikazeigaku', '')
      this.beforeHaishaKbn = null
    },
    onSaveShiharaiTsukoryo: function (target, shiharaiTsukoryo) {
      if (!shiharaiTsukoryo) { return false }

      const shiharaiHaywayPrice = this.removeComma(shiharaiTsukoryo)
      if (!window.isFinite(shiharaiHaywayPrice)) { return }
      target.shiharaiTsukoryo = filter.numericFormatter(shiharaiHaywayPrice)
      target.shiharaiZeinukigaku = filter.numericFormatter(String(this.taxExcludedCalculation(shiharaiHaywayPrice)))
      this.rec.vwUriageList.splice()
    },
    onSaveUriageInfo: function (row, target, input) {
      if (input === undefined) { return false }
      const inputPrice = this.removeComma(input)
      if (!window.isFinite(inputPrice)) { return }
      row[target] = filter.numericFormatter(inputPrice)
      this.rec.vwUriageList.splice()
    },
    // ----------------------------------------------------------------------------------------------------
    // 日報Noから各データを反映
    // ----------------------------------------------------------------------------------------------------
    // ポップアップから日報No選択時
    nippoNoSearchDialogSync: function (p) {
      console.log(' **** XXXXX **** nippoNoSearchSync', p)
      this.recUriageInfo.unkoJissekiNo = p
      this.nippoNoSearchSync()
    },
    // 日報No反映ボタン選択時
    nippoNoSearchSync: function (p) {
      console.log(' **** XXXXX **** nippoNoSearchSync', p)
      // 入力済みのデータを一時退避
      this.tmpSaveUriageInfo()
      this.getNippoData()
    },
    getNippoData: function () {
      return new Promise((resolve) => {
        this.conditionsNippo.unkoJissekiNo = this.recUriageInfo.unkoJissekiNo
        console.log(this.recUriageInfo.unkoJissekiNo)
        this.HttpClient
          .post('/api/v1/VwCThrcod00104/NippoSearch', this.conditionsNippo)
          .then((data) => {
            this.recUriageInfo = {}
            if (data.payload) {
              // ==================================================
              // 日報情報
              // ==================================================-
              if (data.payload.eigyoshoCd) { this.recUriageInfo.eigyoshoCd = data.payload.eigyoshoCd }
              if (data.payload.eigyoshoNm) { this.recUriageInfo.eigyoshoNm = data.payload.eigyoshoNm }
              if (data.payload.unkoJissekiNo) { this.recUriageInfo.unkoJissekiNo = data.payload.unkoJissekiNo }
              if (data.payload.sharyoNo) { this.recUriageInfo.sharyoNo = data.payload.sharyoNo }
              if (data.payload.sharyoPlateNo) { this.recUriageInfo.sharyoPlateNo = data.payload.sharyoPlateNo }
              if (data.payload.jininCd) { this.recUriageInfo.jininCd = data.payload.jininCd }
              if (data.payload.jomuinNm) { this.recUriageInfo.jomuinNm = data.payload.jomuinNm }
              if (data.payload.hacchusakiCd) { this.recUriageInfo.hacchusakiCd = data.payload.hacchusakiCd }
              if (data.payload.hacchusakiNm) { this.recUriageInfo.hacchusakiNm = data.payload.hacchusakiNm }
              if (data.payload.haishaKbn) { this.recUriageInfo.haishaKbn = data.payload.haishaKbn }
            } else {
              this.$refs.unkoJissekiNo[this.Ctrls.SET_INVALID_METHOD](message.get('COMI0101'))
            }
            // 入力済みのデータを復元
            this.tmpRestoreUriageInfo()
            resolve()
          })
      })
    },
    tmpSaveUriageInfo: function () {
      if (this.recUriageInfo.sagyoMeisaiNo) { this.recUriageInfoTmp.sagyoMeisaiNo = this.recUriageInfo.sagyoMeisaiNo }
      if (this.recUriageInfo.uriageEigyoshoId) { this.recUriageInfoTmp.uriageEigyoshoId = this.recUriageInfo.uriageEigyoshoId }
      if (this.recUriageInfo.renrakuBiko) { this.recUriageInfoTmp.renrakuBiko = this.recUriageInfo.renrakuBiko }
      if (this.recUriageInfo.uriageKingaku) { this.recUriageInfoTmp.uriageKingaku = this.recUriageInfo.uriageKingaku }
      if (this.recUriageInfo.shiharaiUnchin) { this.recUriageInfoTmp.shiharaiUnchin = this.recUriageInfo.shiharaiUnchin }
      if (this.recUriageInfo.shiharaiTsukoryo) { this.recUriageInfoTmp.shiharaiTsukoryo = this.recUriageInfo.shiharaiTsukoryo }
      if (this.recUriageInfo.shiharaiHikazeigaku) { this.recUriageInfoTmp.shiharaiHikazeigaku = this.recUriageInfo.shiharaiHikazeigaku }
      if (this.recUriageInfo.haishaKbn) { this.beforeHaishaKbn = this.recUriageInfo.haishaKbn }
    },
    tmpRestoreUriageInfo: function () {
      if (this.recUriageInfoTmp.sagyoMeisaiNo) { this.recUriageInfo.sagyoMeisaiNo = this.recUriageInfoTmp.sagyoMeisaiNo }
      if (this.recUriageInfoTmp.uriageEigyoshoId) { this.recUriageInfo.uriageEigyoshoId = this.recUriageInfoTmp.uriageEigyoshoId }
      if (this.recUriageInfoTmp.renrakuBiko) { this.recUriageInfo.renrakuBiko = this.recUriageInfoTmp.renrakuBiko }
      if (this.recUriageInfoTmp.uriageKingaku) { this.recUriageInfo.uriageKingaku = this.recUriageInfoTmp.uriageKingaku }
      if (this.recUriageInfoTmp.shiharaiUnchin) { this.recUriageInfo.shiharaiUnchin = this.recUriageInfoTmp.shiharaiUnchin }
      if (this.recUriageInfoTmp.shiharaiTsukoryo) { this.recUriageInfo.shiharaiTsukoryo = this.recUriageInfoTmp.shiharaiTsukoryo }
      if (this.recUriageInfoTmp.shiharaiHikazeigaku) { this.recUriageInfo.shiharaiHikazeigaku = this.recUriageInfoTmp.shiharaiHikazeigaku }
    },
    onCancelButtonClick: function (e) {
      console.log('onCancelButtonClick', e)
      const self = this
      const opt = {
        restoreInputsPromise: function (data) {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.hinmokuCount = self.cloneData.hinmokuCount
            self.hatsuchiSwitch = self.cloneData.hatsuchiSwitch
            self.chakuchiSwitch = self.cloneData.chakuchiSwitch
            self.hatsuchiHmsSwitch = self.cloneData.hatsuchiHmsSwitch
            self.chakuchiHmsSwitch = self.cloneData.chakuchiHmsSwitch
            resolve()
          })
        }
      }
      this.cancelInputs(opt)
    },
    onDeleteButtonClick: function (e) {
      const self = this
      const opt = {
        deleteRequestPromise: function () {
          return new Promise(resolve => {
            self.rec = self.cloneData.rec
            self.HttpClient.post('/api/v1/THrcod00100/KamotsuInfoDelete', self.rec).then(data => {
              resolve(data)
            })
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        getSavedInputMethod: function () {
          return {
            ohfukuSbt: self.rec.vwJuchuKihon.ohfukuSbt,
            seikyuShashuSbt: self.rec.vwJuchuKihon.seikyuShashuSbt
          }
        },
        settingReloadWindow: function () {
          return true
        }
      }
      this.delete(opt)
    },
    deleteValidate: function () {
      return true
    },
    onNewButtonClick: function () {
      console.log('NewButton pushed')
      this.Effects.loadStart()
      const p = modals.showConfirm
      p('COMQ0006').then((ok) => {
        console.log('clearInputs')
        if (ok === false || ok === undefined) { return }
        this.initialize()
        // this.clearInvalidMessage(this.$refs)
        // this.initBindVariables()
        this.DeleteButtonDisp = false
        this.NewButtonDisp = false
        // this.CopyButtonDisp = true
        this.isReadonlyMode1 = false
        this.isReadonlyMode2 = false
      })
      this.Effects.loadComplete()
    },
    onCopyButtonClick: function () {
      this.copyMode = 1
      if (this.rec.vwJuchuKihon.id === 0) {
        return this.$refs.juchuNo.onDialogButtonClick()
      }
      const p = modals.showConfirm
      p('COMQ0004').then((ok) => {
        if (ok === false || ok === undefined) { return }
        this.kamotsuNoSync(this.rec.vwJuchuKihon.juchuNo)
      })
    },
    onSaveButtonClick: function () {
      const self = this
      const opt = {
        registerRequestPromise: self.registerPromise,
        registerResponsePromise: (data) => {
          return new Promise(resolve => {
            self.rec.vwJuchuKihon.id = data.payload.vwJuchuKihon.id
            self.rec.vwJuchuKihon.juchuNo = data.payload.vwJuchuKihon.juchuNo
            self.registerMode = 1
            this.fetchData()
            resolve()
          })
        },
        getIdMethod: () => {
          return self.rec.vwJuchuKihon.id
        },
        continuousInputInitializePromise: (id) => {
          return new Promise(resolve => {
            // self.initBindVariables()
            // self.transition(0, { id: self.rec.vwJuchuKihon.id })
            resolve()
          })
        },
        getTransitionBackParams: function () {
          return {
            actionId: 0,
            param: { id: self.id }
          }
        },
        isUpdateModeMethod: function () {
          return true
        },
        isNoRefreshModeMethod: function () {
          return true
        },
        getSavedInputMethod: function () {
          return {
            ohfukuSbt: self.rec.vwJuchuKihon.ohfukuSbt,
            seikyuShashuSbt: self.rec.vwJuchuKihon.seikyuShashuSbt
          }
        }
      }
      this.register(opt)
    },
    registerPromise: function () {
      let f
      if (this.rec.vwJuchuKihon.id === 0) {
        console.log(this.rec, 'KamotsuCreate')
        f = this.HttpClient.post('/api/v1/THrcod00100/KamotsuCreate', this.rec)
      } else {
        console.log(this.rec, 'Update')
        f = this.HttpClient.post('/api/v1/THrcod00100/KamotsuUpdate', this.rec)
      }
      return f
    },
    registerValidate: function () {
      var msg
      if (this.rec.vwJuchuKihon.id !== 0 && this.rec.vwJuchuKihon.juchuNo !== this.cloneData.rec.vwJuchuKihon.juchuNo) {
        this.$refs.juchuNo[this.Ctrls.SET_INVALID_METHOD](message.get('COMV0121'))
        this.setInvalidSummaryMessage('RCOE0004')
        return false
      }
      if (this.rec.vwJuchuKihon.hatsuchiYmd && this.rec.vwJuchuKihon.chakuchiYmd) {
        msg = validators.compareDate(this.rec.vwJuchuKihon.hatsuchiYmd, this.rec.vwJuchuKihon.chakuchiYmd)
        if (msg !== undefined) {
          this.$refs.hatsuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          this.$refs.chakuchiYmd[this.Ctrls.SET_INVALID_METHOD](msg)
          return false
        }
      }
      if (this.rec.vwUriageList.length !== 0) {
        var uriageList = this.rec.vwUriageList.filter((elem) => {
          return elem.uriageEigyoshoId === null
        })
        if (uriageList.length !== 0) {
          this.setInvalidSummaryMessage('RCOE0001')
          return false
        }
      }
      if (this.rec.vwJuchuKihon.id !== 0 && this.seikyuGokeiAmount !== this.uriageKingakuAmount) {
        this.$refs.seikyuGokeiAmount[this.Ctrls.SET_INVALID_METHOD](message.get('COME0021'))
        this.$refs.uriageKingakuAmount[this.Ctrls.SET_INVALID_METHOD](message.get('COME0021'))
        this.setInvalidSummaryMessage('COME0012')
        return false
      }
      var newUriageList = this.rec.vwUriageList.filter((t) => {
        return t.delFlg === false
      })
      if (this.rec.vwJuchuKihon.id === 0 && this.seikyuGokeiAmount !== this.uriageKingakuAmount && newUriageList.length !== 0) {
        this.$refs.seikyuGokeiAmount[this.Ctrls.SET_INVALID_METHOD](message.get('COME0021'))
        this.$refs.uriageKingakuAmount[this.Ctrls.SET_INVALID_METHOD](message.get('COME0021'))
        this.setInvalidSummaryMessage('COME0012')
        return false
      }
      if (this.rec.vwJuchuKihon.id === 0 && this.seikyuGokeiAmount !== this.uriageKingakuAmount && newUriageList.length === 0) {
        const difference = this.seikyuGokeiAmount - this.uriageKingakuAmount
        this.recUriageInfo = {}
        this.recUriageInfo.id = -1
        this.recUriageInfo.editFlg = true
        this.recUriageInfo.delFlg = false

        this.recUriageInfo.uriageEigyoshoId = this.getEigyoshoId(this.usersEigyosho)
        this.recUriageInfo.uriageKingaku = String(difference)
        // 数値項目が入力されていないとき、0を代入
        if (!this.recUriageInfo.shiharaiUnchin) { this.recUriageInfo.shiharaiUnchin = '0' }
        if (!this.recUriageInfo.shiharaiTsukoryo) { this.recUriageInfo.shiharaiTsukoryo = '0' }
        if (!this.recUriageInfo.shiharaiHikazeigaku) { this.recUriageInfo.shiharaiHikazeigaku = '0' }

        if (this.rec.vwUriageList.length > 0) {
          this.rec.vwUriageList.push(this.recUriageInfo)
        } else {
          this.rec.vwUriageList = [this.recUriageInfo]
        }
      }
      return true
    },
    // ----------------------------------------------------------------------------------------------------
    // 内部共通関数
    // ----------------------------------------------------------------------------------------------------
    initBindVariables: function () {
      this.hinmokuCount = 0
      this.rec.vwJuchuKihon = {}
      this.rec.mstKingaku = {}
      this.rec.vwJuchuHinmokuList = []
      this.rec.vwUriageList = []
      this.recDispKingakuKomokuList = []
      this.recDispKingakuInfo = {}
      this.recShohinInfo = {}
      this.recUriageInfo = {}
      this.copyMode = 0
      this.registerMode = 0
      this.fechMode = 0
      this.isReadonlyMode1 = false
      this.isReadonlyMode2 = false
      this.hatsuchiSwitch = false
      this.chakuchiSwitch = false
      this.hatsuchiHmsSwitch = false
      this.chakuchiHmsSwitch = false
      this.hinmeiSwitch = false
      this.shohinSeikyuKingakuMinyuryoku = false
      this.recUriageInfoTmp = {}
      this.rec.vwJuchuKihon.id = 0
      this.$refs.juchuYmd.onCalendarInput(filter.dateFormatter(new Date()))
      this.$refs.hatsuchiYmd.onCalendarInput(filter.dateFormatter(new Date()))
      this.$refs.chakuchiYmd.onCalendarInput(filter.dateFormatter(new Date()))
      this.$refs.seikyuYoteiYmd.onCalendarInput(filter.dateFormatter(new Date()))
      this.$refs.shiharaiYoteiYmd.onCalendarInput(filter.dateFormatter(new Date()))
      this.$set(this.rec.vwJuchuKihon, 'hatsuchiId', '')
      this.$set(this.rec.vwJuchuKihon, 'hatsuchiBiko', '')
      this.$set(this.rec.vwJuchuKihon, 'hatsuchiHms', '')
      this.$set(this.rec.vwJuchuKihon, 'hatsuchiHmsBiko', '')
      this.$set(this.rec.vwJuchuKihon, 'chakuchiId', '')
      this.$set(this.rec.vwJuchuKihon, 'chakuchiBiko', '')
      this.$set(this.rec.vwJuchuKihon, 'chakuchiHms', '')
      this.$set(this.rec.vwJuchuKihon, 'chakuchiHmsBiko', '')
      this.$set(this.recShohinInfo, 'mstHinmeiId', '')
      this.$set(this.recShohinInfo, 'hinmeiBiko', '')
      this.$set(this.recUriageInfo, 'uriageEigyoshoId', '')
      this.$set(this.recUriageInfo, 'unkoJissekiNo', '')
      this.$set(this.recUriageInfo, 'haishaKbn', '')
      this.rec.vwJuchuHinmokuList.HinmokuCount = 0
      this.beforeHaishaKbn = null
      // dd-code-text-boxにbindしている項目は明示的にNullを設定する事
      this.rec.vwJuchuKihon.juchuNo = null
      this.rec.vwJuchuKihon.juchuEigyoshoId = this.getEigyoshoId(this.usersEigyosho)
      this.rec.vwJuchuKihon.teikeiKihonNo = null
      this.rec.vwJuchuKihon.ninushiId = null
      this.rec.vwJuchuKihon.hatsuchiId = null
      this.rec.vwJuchuKihon.oroshisakiId = null
      this.rec.vwJuchuKihon.chakuchiId = null
      this.recShohinInfo.mstHinmeiId = null
      this.recUriageInfo.uriageEigyoshoId = this.getEigyoshoId(this.usersEigyosho)
      this.recUriageInfo.unkoJissekiNo = null
    },
    // データ取得
    getEigyoshoCd: function (pEigyoshoId) {
      var eigyosho = this.eigyoshoList.filter((t) => {
        return t.id === pEigyoshoId
      })
      if (eigyosho.length > 0) {
        return eigyosho[0].eigyoshoCd
      }
      return ''
    },
    getEigyoshoNm: function (pEigyoshoId) {
      var eigyosho = this.eigyoshoList.filter((t) => {
        return t.id === pEigyoshoId
      })
      if (eigyosho.length > 0) {
        return eigyosho[0].eigyoshoNm
      }
      return ''
    },
    getEigyoshoId: function (pEigyoshoCd) {
      const target = filter.dateFormatter(new Date())
      var eigyosho = this.eigyoshoList.filter((t) => {
        return t.eigyoshoCd === pEigyoshoCd && t.tekiyoStartYmdDisp <= target && t.tekiyoEndYmdDisp >= target
      })
      if (eigyosho.length > 0) {
        return eigyosho[0].id
      }
      return ''
    },
    getHinmeiCd: function (pHinmeiId) {
      var hinmei = this.hinmeiList.filter((t) => {
        return t.id === pHinmeiId
      })
      if (hinmei.length > 0) {
        return hinmei[0].hinmeiCd
      }
      return ''
    },
    getHinmeiNm: function (pHinmeiId) {
      var hinmei = this.hinmeiList.filter((t) => {
        return t.id === pHinmeiId
      })
      if (hinmei.length > 0) {
        return hinmei[0].hinmeiNm
      }
      return ''
    },
    getShubetsuNm: function (pSbtShuruiCd, pSbtCd) {
      var shubetsu = this.shubetsuList.filter((t) => {
        return t.sbtShuruiCd === pSbtShuruiCd && t.sbtCd === pSbtCd
      })
      if (shubetsu.length > 0) {
        return shubetsu[0].sbtNm
      }
      return ''
    },
    getKubunNm: function (pKbnShuruiCd, pKbnCd) {
      var kubun = this.kubunList.filter((t) => {
        return t.kbnShuruiCd === pKbnShuruiCd && t.code === pKbnCd
      })
      if (kubun.length > 0) {
        return kubun[0].codeNm
      }
      return ''
    },
    getSharyoNm: function (sharyoNo) {
      var sharyo = this.sharyoList.filter((t) => {
        return t.sharyoNo === sharyoNo
      })
      if (sharyo.length > 0) {
        return sharyo[0].jidoshaHyojiNm
      } else {
        return ''
      }
    },
    rowColorClass: function (item) {
      return item.delFlg === true ? 'row_delete' : ''
    },
    removeComma: function (num) {
      if (num === '' || num === undefined || num === null) { return }

      if (window.isFinite(num) === true) {
        return num
      }
      var removedNum = num.replace(/,/g, '')
      return removedNum
    },
    // 税抜き計算
    taxExcludedCalculation (data) {
      // 通行料が入力されていない場合
      if (data === undefined || data === '') { return 0 }
      if (data === 0) { return 0 }

      const zeinukiKingaku = tax.calcWithoutTax5u6d(data, new Date())

      return zeinukiKingaku
    },
    onSwitchingHatsuchiCodeToBiko (f) {
      this.hatsuchiSwitch = f
    },
    onSwitchingChakuchiCodeToBiko (f) {
      this.chakuchiSwitch = f
    },
    onSwitchingHatsuchiHmsToBiko (f) {
      this.hatsuchiHmsSwitch = f
    },
    onSwitchingChakuchiHmsToBiko (f) {
      this.chakuchiHmsSwitch = f
    },
    onSwitchingHinmeiCodeToBiko (f) {
      this.hinmeiSwitch = f
    }
  }
}
